module.exports = __webpack_public_path__ + "img/2_278.e3a509c0.png";